/**
 * BLOCK: How-To Schema
 */

import styling from './styling';
import './style.scss';
import lazyLoader from '@Controls/lazy-loader';
import React, { useEffect, lazy, Suspense } from 'react';
import { compose } from '@wordpress/compose';
import { withSelect } from '@wordpress/data';
let prevState;

const Settings = lazy(() =>
	import(/* webpackChunkName: "chunks/how-to/settings" */ './settings')
);
const Render = lazy(() =>
	import(/* webpackChunkName: "chunks/how-to/render" */ './render')
);

const WPSPhowToComponent = (props) => {
	useEffect(() => {
		// Replacement for componentDidMount.

		// Assigning block_id in the attribute.
		props.setAttributes({ block_id: props.clientId.substr(0, 8) });

		props.setAttributes({
			schema: JSON.stringify(props.schemaJsonData),
		});

		// Pushing Style tag for this block css.
		const $style = document.createElement('style');
		$style.setAttribute(
			'id',
			'wpsp-how-to-schema-style-' + props.clientId.substr(0, 8)
		);
		document.head.appendChild($style);

		prevState = props.schemaJsonData;
	}, []);

	useEffect(() => {
		// Replacement for componentDidUpdate.

		if (
			JSON.stringify(props.schemaJsonData) !== JSON.stringify(prevState)
		) {
			props.setAttributes({
				schema: JSON.stringify(props.schemaJsonData),
			});

			prevState = props.schemaJsonData;
		}
		const element = document.getElementById(
			'wpsp-how-to-schema-style-' + props.clientId.substr(0, 8)
		);

		if (null !== element && undefined !== element) {
			element.innerHTML = styling(props);
		}
	}, [props]);

	return (
		<Suspense fallback={lazyLoader()}>
			<Settings parentProps={props} />
			<Render parentProps={props} />
		</Suspense>
	);
};
export default compose(
	withSelect((select, ownProps) => {
		let urlChk = '';
		if (
			'undefined' !== ownProps.attributes.mainimage &&
			null !== ownProps.attributes.mainimage &&
			'' !== ownProps.attributes.mainimage
		) {
			urlChk = ownProps.attributes.mainimage.url;
		}

		let toolsData = {};
		let materialsData = {};
		let stepsData = {};
		const jsonData = {
			'@context': 'https://schema.org',
			'@type': 'HowTo',
			name: ownProps.attributes.headingTitle,
			description: ownProps.attributes.headingDesc,
			image: {
				'@type': 'ImageObject',
				url: urlChk,
				height: '406',
				width: '305',
			},
			totalTime: '',
			estimatedCost: [],
			tool: [],
			supply: [],
			step: [],
		};

		if (ownProps.attributes.showTotaltime) {
			jsonData.totalTime = 'PT' + ownProps.attributes.time + 'M';
		}

		if (ownProps.attributes.showEstcost) {
			jsonData.estimatedCost = {
				'@type': 'MonetaryAmount',
				currency: ownProps.attributes.currencyType,
				value: ownProps.attributes.cost,
			};
		}

		if (ownProps.attributes.showTools) {
			ownProps.attributes.tools.forEach((tools, key) => {
				toolsData = {
					'@type': 'HowToTool',
					name: tools.add_required_tools,
				};
				jsonData.tool[key] = toolsData;
			});
		}

		if (ownProps.attributes.showMaterials) {
			ownProps.attributes.materials.forEach((materials, key) => {
				materialsData = {
					'@type': 'HowToSupply',
					name: materials.add_required_materials,
				};
				jsonData.supply[key] = materialsData;
			});
		}

		const getChildBlocks = select('core/block-editor').getBlocks(
			ownProps.clientId
		);

		getChildBlocks.forEach((steps, key) => {
			stepsData = {
				'@type': 'HowToStep',
				url: steps.attributes.ctaLink,
				name: steps.attributes.howtoChildTitle,
				text: steps.attributes.headingDesc,
				image: steps.attributes.iconImage.url,
			};
			jsonData.step[key] = stepsData;
		});

		return {
			schemaJsonData: jsonData,
		};
	})
)(WPSPhowToComponent);
